var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9583 112.82H36C30.2701 112.82 25.625 108.175 25.625 102.445V29.9072C25.625 24.1773 30.27 19.5322 36 19.5322H76.5729C79.3917 19.5322 82.0892 20.6792 84.0448 22.7093L95.4303 34.5281C97.2928 36.4615 98.3333 39.0415 98.3333 41.7261V102.445C98.3333 108.175 93.6883 112.82 87.9583 112.82Z",
    fill: "#E1E1F0",
    stroke: "#03014F",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0417 18.9072V37.0165C76.0417 39.7779 78.2802 42.0165 81.0417 42.0165H98.9583",
    stroke: "#03014F",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 63.5509C50.5208 63.0257 72.3958 64.0756 80.2083 62.5",
    stroke: "#03014F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 78.7921C50.5208 78.2669 70.8333 76.6913 80.2083 78.7926",
    stroke: "#03014F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 92.7541C50.5208 92.2289 59.375 91.1802 66.6667 92.7548",
    stroke: "#03014F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_700_729)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_729",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 54,
    height: 54
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 0H10V54H64V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 0C37.9167 14.5151 49.4848 26.0834 64 27C49.4848 27.9167 37.9167 39.4848 37 54C36.0834 39.4848 24.5151 27.9167 10 27C24.5151 26.0834 36.0834 14.5151 37 0Z",
    fill: "#9492DD"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_700_729)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_700_729",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 86,
    width: 33,
    height: 33
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110 119L110 86L77 86L77 119L110 119Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_700_729)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3893 119L110 102.5L93.3893 86L93.3893 102.28L77 86L77 119L93.3893 102.72L93.3893 119Z",
    fill: "#BBB9E4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_700_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_700_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(110 86) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateContent);
export default __webpack_public_path__ + "static/media/create-content.5a2b0654e553d0f510afa33d42872178.svg";
export { ForwardRef as ReactComponent };